// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyCAK28TUdPYaOhKa71enMfba1EnvLM6Hdw",
  authDomain: "zia-swga.firebaseapp.com",
  projectId: "zia-swga",
  storageBucket: "zia-swga.appspot.com",
  messagingSenderId: "742420606527",
  appId: "1:742420606527:web:5e8d2882efe81d090b128a",
  measurementId: "G-CZ7CNMXEQ9"
}